import { Box, Link, Typography } from '@mui/material'

const ResouceLink = ({ href, children }: { href: string; children: React.ReactNode }) => (
  <Box my={3}>
    <Link href={href}>
      <Typography variant="h6">{children}</Typography>
    </Link>
  </Box>
)
export default function Resources() {
  return (
    <Box mx={10} my={6}>
      <Typography variant="h4" sx={{ mb: 6, textAlign: 'center' }}>
        Resources
      </Typography>
      <Typography variant="body1" sx={{ mb: 4 }}>
        Explore our resources to understand how to use Elute effectively.
      </Typography>
      <ResouceLink href="/resources/toadd">Whitepaper - The Benchmarking Blindspot</ResouceLink>
      <ResouceLink href="/resources/toadd">Whitepaper - Pure Play Benchmarking for Brokers</ResouceLink>
      <ResouceLink href="/resources/toadd">Whitepaper - Consistency Over Guesswork</ResouceLink>
      <ResouceLink href="/resources/property-metrics">Understanding the 4 Key Metrics</ResouceLink>
      <ResouceLink href="/resources/strategic-focus-gap">Understanding the Strategic Focus Gap</ResouceLink>
    </Box>
  )
}
